import { env } from '@/shared/utils/env';

// Every message to or from the Collabora frame names that frame's origin —
// never '*'. The editor frames carry document text (selections, in-place edit
// ops, placeholder values), so a '*' target would hand them to whatever page
// happened to be loaded in the frame, and a prefix test on event.origin
// (`startsWith`) let https://collabora.example.com.evil.net through.

/** `scheme://host[:port]` of `url`, or null when it is empty or not absolute. */
export function originOf(url) {
  if (!url) return null;
  try {
    const { origin } = new URL(url);
    return origin && origin !== 'null' ? origin : null;
  } catch {
    return null;
  }
}

/**
 * The Collabora origin this deployment is configured with: runtime env
 * VITE_COLLABORA_URL (chart env; the dev compose sets it too), which is the
 * origin Collabora's discovery advertises. The agent panel runs INSIDE the
 * Collabora frame and has no other way to learn it — cool.html is served with
 * `Referrer-Policy: no-referrer`, so document.referrer is empty there.
 */
export function configuredCollaboraOrigin() {
  return originOf(env('VITE_COLLABORA_URL'));
}
